import { render } from "./IVRVoicemailsView.vue?vue&type=template&id=45d91766&scoped=true"
import script from "./IVRVoicemailsView.vue?vue&type=script&lang=js"
export * from "./IVRVoicemailsView.vue?vue&type=script&lang=js"

import "./IVRVoicemailsView.vue?vue&type=style&index=0&id=45d91766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d91766"]])

export default __exports__